export default "__VITE_ASSET__ImIn5ETx__"